// extracted by mini-css-extract-plugin
module.exports = {"Rank":"Rank--E0QUw","header":"header--1L5n6","headerLeft":"headerLeft--1YeZj","headerRight":"headerRight--N4H4D","content":"content--pv21F"};